var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard32(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.188,
    height: 21.564,
    viewBox: "0 0 23.188 21.564",
    opacity: 0.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19266",
    "data-name": "Path 19266",
    d: "M23.188,7.635A4.147,4.147,0,0,0,19.052,3.5H4.135a4.134,4.134,0,0,0-.067,8.267V23.209a1.86,1.86,0,0,0,1.855,1.855h6.714V5.819h2.319V25.064h2.309a1.86,1.86,0,0,0,1.855-1.855V11.767A4.146,4.146,0,0,0,23.188,7.635Zm-20.869,0A1.817,1.817,0,0,1,4.068,5.822V9.448A1.817,1.817,0,0,1,2.319,7.635Zm16.8,1.813V5.822a1.814,1.814,0,0,1,0,3.626Z",
    transform: "translate(0 -3.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard32);
export default __webpack_public_path__ + "static/media/card32.b7d7ff80122337a629a046a5ad997d41.svg";
export { ForwardRef as ReactComponent };